import React from "react";

import Flex from "./base/flex";
import Link from "./base/link";

import { useContentContext } from "../context/content-context";

const SecondaryNavigation = ({ handleISIClick, children, ISIScrollButton }) => {
  const { isHCP, language } = useContentContext();
  const isSpanish = language === "esp";

  return (
    <Flex
      flexDirection={["column", "column", "row"]}
      mb={isHCP ? 0 : [0, 0, "15px"]}
      justifyContent="flex-end"
    >
      <ISIScrollButton>
        <Link
          variant={
            isHCP
              ? "hcpSubnav"
              : isSpanish
              ? "patientSubnavEsp"
              : "patientSubnav"
          }
          onClick={handleISIClick}
        >
          {isSpanish
            ? "Información importante de seguridad"
            : "Important Safety Information"}
        </Link>
      </ISIScrollButton>

      {children}
    </Flex>
  );
};

export default SecondaryNavigation;
